import React from "react";
import MapImg from "../../../Assets/Images/about/Map.png";
import AboutHeadings from "./AboutHeadings";

const AboutHistory = () => {
  return (
    <div className="px-4 md:px-[5rem] bg-[#7FCEE226]">
      <div className="grid grid-cols-1 xl:grid-cols-2 py-6 gap-8 min-h-[600px]">
        {/* Left Side */}
        <div
          className="flex flex-col justify-between col-span-1"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div className="">
            <AboutHeadings
              title={"Our History & Our Approach"}
              textAlign="left"
            />
            <p className="text-base md:text-lg leading-relaxed text-[#555] text-justify tracking-wide mt-4">
              Being an educationalist and mentor, Er. Alexander Das worked with
              engineering students and realized how those from poor economic
              backgrounds struggle to continue higher education and subsequently
              face employment challenges. With the philosophy "Instead of
              running behind jobs, how youth can create jobs for others," our
              founder initiated remarkable changes in the local entrepreneurship
              ecosystem. We established incubation centers and entrepreneurship
              parks where potential youth receive comprehensive support to
              become successful entrepreneurs.
            </p>
          </div>

          <div className="py-4">
            <AboutHeadings title={"Our Goal"} textAlign="left" />
            <ul className="flex flex-col gap-y-1.5 text-base md:text-lg font-medium leading-relaxed text-[#555] text-justify tracking-wide mt-2">
              <li>• Create 1 Crore+ green advocates in India by 2030</li>
              <li>• Establish Solar Energy hubs across India</li>
              <li>• Promote plastic-free homes and communities</li>
              <li>• Skill development for 10 lakh rural youth by 2030</li>
              <li>• Develop youth skills in sports for career pathways</li>
              <li>• STEM education and careers for females in rural India</li>
              <li>• Promote health and well-being in rural communities</li>
              <li>• Develop women entrepreneurs in rural India</li>
              <li>
                • Create Drone Didis in rural India to generate livelihood
              </li>
            </ul>
          </div>
        </div>

        {/* Right Side - Map */}
        <div
          className="col-span-1 flex justify-center items-center py-6 overflow-hidden"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="400"
        >
          <div className="w-full h-full">
            <img
              src={MapImg}
              alt="Map Illustration"
              className="w-full h-full object-cover rounded-lg transform transition-transform duration-700 hover:scale-105"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutHistory;
